export default __webpack_public_path__ + "static/media/visionarios.f9c8b910.png";